export default __webpack_public_path__ + "static/media/blueslider5.23404147.png";